import { Component } from '@angular/core';
import { ReportManagementService } from '../../services/report-management.service';

@Component({
    selector: 'app-report-save',
    templateUrl: './report-save.component.html'
})

export class SaveReportComponent {
    constructor(private reportManagementService: ReportManagementService) {
        this.save();
    }

    save() {
        this.reportManagementService.saveReport();
    }
}



// WEBPACK FOOTER //
// ./src/app/report/components/save/report-save.component.ts